import { render } from "./CheckDetail.vue?vue&type=template&id=6a0c05a0"
import script from "./CheckDetail.vue?vue&type=script&lang=js"
export * from "./CheckDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__